import { useEffect, useRef } from 'react';
import { Navigate } from 'react-router-dom';

import { OnboardingModule } from '../../modules/onboarding/OnboardingModule.tsx';
import type { OnboardingModuleProps } from '../../modules/onboarding/types.ts';
import { useCreateAllTrainingOrders } from '../../modules/orderManagement/hooks/useCreateAllTrainingOrders.ts';
import { SubscriptionModule } from '../../modules/subscription/SubscriptionModule.tsx';
import { selectIsOnboardingComplete } from '../../redux/features/selectors/accountSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useToolkitControllerGlobal } from '../hooks/useToolkitControllerGlobal.ts';

const InjectedSubscriptionModule: OnboardingModuleProps['SubscriptionModule'] = (props) => (
  <SubscriptionModule
    {...props}
    // NOTE: This is currently not used as we don't accept payment methods that require
    // redirection: https://docs.stripe.com/payments/payment-methods/overview#bank-redirects
    redirectURL="https://toolkit.aloftappraisal.com/orders"
  />
);

export const OnboardingRouteElement = () => {
  const { subscription } = useToolkitControllerGlobal();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const isOnboardingCompleteOnMount = useRef(isOnboardingComplete);

  const createAllTrainingOrders = useCreateAllTrainingOrders(false);

  useEffect(() => {
    createAllTrainingOrders();
  }, []);

  if (subscription.hasActiveSubscription) return <Navigate to="/orders" />;

  if (isOnboardingCompleteOnMount.current) return <Navigate to="/subscribe" />;

  return <OnboardingModule SubscriptionModule={InjectedSubscriptionModule} />;
};
